package fr.frux.shared.dto

import kotlinx.serialization.Serializable
import kotlin.time.Instant

/** Observation du statut d'un arbre avec horodatage et observateur. */
@Serializable
data class TreeStatusObservationDto(
    val status: TreeStatusDto,
    @Serializable(with = InstantEpochMillisSerializer::class)
    val observedAt: Instant,
    val observerUsername: String? = null,
)

/** Requête d'observation du statut d'un arbre. */
@Serializable
data class ObserveTreeStatusRequest(
    val status: TreeStatusDto,
)
